import { Button } from '@calendly/ui/components/button'
import { Popup, Body as PopupBody } from '@calendly/ui/components/popup'

import { useI18n } from 'locales'
import { useBooleanState } from 'hooks/useBooleanState'

import Body from './body'

const Login = () => {
  const { i18n } = useI18n()
  const [isPopupOpen, openPopup, closePopup] = useBooleanState(false)

  return (
    <>
      <Button size="small" wide onClick={openPopup}>
        {i18n.t('booking.mutual_availability.signin')}
      </Button>
      <Popup isOpen={isPopupOpen} onClose={closePopup}>
        <PopupBody>
          <Body closePopup={closePopup} />
        </PopupBody>
      </Popup>
    </>
  )
}

export default Login
